import {
  CARE_SERVICE_ORGANS_PARENT_KEY,
  CARE_SERVICE_ORGANS_SUB_KEY,
  CareServiceOrgansKey,
  CareServiceReportOrgansStructure,
} from '@/api';

export interface CareServiceOrganItem {
  key: CareServiceOrgansKey;
  sub?: CareServiceOrganItem[];
  value: string;
}

export interface CareServiceReportOrganItem extends CareServiceOrganItem {
  disabled?: boolean;
}

export interface CareServiceReportOrgan extends CareServiceReportOrgansStructure {
  structure: CareServiceReportOrganItem[];
}

export type CareServiceReportLinkProgress =
  'Completed' | 'Error' | 'InProgress' | 'missingInput' | 'oncorad';

export const CARE_SERVICE_REPORT_LINK_KEY = {
  AI_FINDINGS: 'ai_findings',
  FINAL_IMPRESSIONS: 'final_impressions',
  KEY_IMAGES: 'key_images',
  PREVIEW: 'preview',
  QUALITY_REVIEW: 'quality_review',
  REASON_FOR_SCAN: 'reason_for_scan',
  ...CARE_SERVICE_ORGANS_PARENT_KEY,
  ...CARE_SERVICE_ORGANS_SUB_KEY,
} as const;

export type CareServiceReportLinkKey =
  (typeof CARE_SERVICE_REPORT_LINK_KEY)[keyof typeof CARE_SERVICE_REPORT_LINK_KEY];

export type CareServiceReportLink = {
  disabled?: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>> | string;
  key: CareServiceReportLinkKey;
  progress: CareServiceReportLinkProgress | null;
  sub?: CareServiceReportLink[];
  title: string;
};
